import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { Customerservice } from 'src/app/model/customerservice.model';
import { CustomergroupService } from 'src/app/services/customergroup.service';
import { RemoveModalCustomerserviceUserComponent } from 'src/app/modal/remove-modal-customerservice-user/remove-modal-customerservice-user.component';
import { ChangeUserGroupComponent } from 'src/app/modal/change-user-group/change-user-group.component';
import { ChangeUserGroupSingleComponent } from 'src/app//modal/change-user-group-single/change-user-group-single.component';

@Component({
  standalone: false,
  selector: 'app-view-member-details',
  templateUrl: './view-member-details.component.html',
  styleUrls: ['./view-member-details.component.scss']
})
export class ViewMemberDetailsComponent implements OnInit {

  public customerservice = new Customerservice();
  private subscriptions = new Subscription();

  memberId: any;
  memberDetails: any;
  groupId: string = null;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  singleUserId: any;
  checkLengthOfUser: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private customergroupService: CustomergroupService,
  ) {

    localStorage.setItem('expandNavUser', 'true');

    const routeLink = this.sideNavService.routingChunks({
      name: 'Users',
      subNav: '3',
      subNavLink: '',
      //subNavLink: '/landscaping-and-vegetation/list-of-plants-trees',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {

    this.groupId = null;
    this.fromDetailsPage = 'Yes';

    this.route.params.subscribe((params) => {
      this.memberId = params['id'];
    });

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');

    this.getMemberDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavUser');
    this.subscriptions.unsubscribe();
  }


  getMemberDetails() {
    this.customergroupService.getMemberDetailsSingle(this.memberId).subscribe((res) => {
      if (res?.isValid === true) {
        this.memberDetails = res;
        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.memberDetails.data);
        console.log(this.checkedOnlyUsersList);
      }
    });
  }

  openModal(userName: string, userNameInShort: string, userId: string, groupId: any, fromDetailsPage: string): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemoveModalCustomerserviceUserComponent, modalOptions);

    modalRef.componentInstance.userName = userName;
    modalRef.componentInstance.userNameInShort = userNameInShort;
    modalRef.componentInstance.userId = userId;
    modalRef.componentInstance.groupId = groupId;
    modalRef.componentInstance.fromDetailsPage = fromDetailsPage;
  }

  openModalMoveGroup(checkedOnlyUsersList: any): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(ChangeUserGroupSingleComponent, modalOptions);

    modalRef.componentInstance.listofusers = checkedOnlyUsersList;
    modalRef.componentInstance.singleUserId = this.memberId;

  }

  goToEditPage(id) {
    this.router.navigate(['/update-new-customer/' + id]);
  }

}
